/*
 * Public API Surface of auth
 */

export * from './lib/auth-form.component';
export * from './lib/auth-form.module';
